import { ChevronRightIcon, StarFilledIcon, StarIcon } from '@calizahq/react-components-v2'
import React from 'react'
import { useNavigate } from 'react-router-dom'

type Props = {
  hostName: string | undefined
  jobId: number
  jobTemplate: string
  scheduleDate: string
  stars: number
  toggleHostFeedbackModal: () => void
}

export const HostRating = ({ jobTemplate, jobId, hostName, toggleHostFeedbackModal, scheduleDate, stars }: Props) => {
  const unassigned = hostName === undefined || hostName === null
  const filledStars = [...Array(stars).keys()]
  const noRating = filledStars.length === 0
  const emptyStars = [...Array(5 - stars).keys()]
  const navigate = useNavigate()

  return (
    <div className="items-left flex w-full flex-col justify-between md:mb-4" role="presentation">
      <div className="items-left flex w-full flex-row py-4">
        <p
          className="text-label-lg cursor-pointer underline leading-120 text-primary"
          onClick={() => navigate(`/jobs/${jobId}`)}
          role="presentation"
        >
          {jobTemplate}
        </p>
        <p className="text-label-lg leading-120 text-tertiary ml-2 ">{scheduleDate}</p>
      </div>
      <div className="flex items-center">
        <div className="flex flex-col">
          <h6 className="w-full text-label-md leading-120 text-primary">{unassigned ? 'Unassigned' : hostName}</h6>
          <h6 className="w-full text-label-xs leading-120 mt-2 text-tertiary">Host</h6>
        </div>
        <div className="flex ml-4">
          {filledStars.map((index) => (
            <StarFilledIcon className="w-5" color="#FFD426" key={index} />
          ))}
          {emptyStars.map((index) => (
            <StarIcon className="w-5" color={noRating ? '#A7A6A4' : '#FFD426'} key={index} />
          ))}
        </div>
      </div>
      {noRating && !unassigned ? (
        <div className="flex items-left mt-2">
          <button
            className={'font-bold text-semantic-success mr-2 flex h-5 w-full hover:underline'}
            onClick={toggleHostFeedbackModal}
          >
            <p className="text-sm leading-120">Provide Host feedback</p>
            <ChevronRightIcon className="ml-2 h-4 w-3 cursor-pointer icon-tertiary" />
          </button>
        </div>
      ) : null}
    </div>
  )
}
